
import { ACCOUNT_STATUS } from '@/utils/accountStatus'

export const DELETION_DAYS = 90

const MS_PER_DAY = 1000 * 60 * 60 * 24

function toUTCDate(value) {
  if (!value)
    return null

  const text = String(value).substring(0, 10)
  const [year, month, day] = text.split('-').map(Number)

  if (!year || !month || !day)
    return null

  return Date.UTC(year, month - 1, day)
}

function toISO(timestamp) {
  return new Date(timestamp).toISOString().substring(0, 10)
}

export function todayISO() {
  return new Date().toISOString().substring(0, 10)
}

export function deletionDateFor(canceledAt, days = DELETION_DAYS) {
  const base = toUTCDate(canceledAt)

  if (base === null)
    return null

  return toISO(base + days * MS_PER_DAY)
}

export function daysUntil(date, from = todayISO()) {
  const target = toUTCDate(date)
  const start = toUTCDate(from)

  if (target === null || start === null)
    return null

  return Math.round((target - start) / MS_PER_DAY)
}

export function formatBR(date) {
  if (!date)
    return '-'

  const [year, month, day] = String(date).substring(0, 10).split('-')

  return `${day}/${month}/${year}`
}

export function deletionLabelFor(baseDate, from = todayISO()) {
  const date = deletionDateFor(baseDate)

  if (!date)
    return null

  const days = daysUntil(date, from)

  if (days > 1)
    return `Em ${days} dias — ${formatBR(date)}`

  if (days === 1)
    return `Amanhã — ${formatBR(date)}`

  if (days === 0)
    return `Hoje — ${formatBR(date)}`

  return `Prazo vencido em ${formatBR(date)}`
}

export const NOTICE_ABSENT = 'absent'
export const NOTICE_WITH_DATE = 'date'

export const PAST_NOTICE_DATE_ERROR = 'O aviso prévio não pode terminar numa data passada.'

export const ABSENT_NOTICE_APPLIED = 'Sem aviso prévio a conta é cancelada de imediato: ' +
  'o status passou para Cancelada e a contagem para exclusão começou hoje.'

const NOTICE_STATUSES = [ACCOUNT_STATUS.IN_NOTICE, ACCOUNT_STATUS.CANCELED]

export function hasNoticeRecord(account) {
  return !!account.subscription_notice_mode &&
    NOTICE_STATUSES.includes(account.subscription_type)
}

export function applyNoticeMode(account, from = todayISO()) {
  const mode = account.subscription_notice_mode

  if (mode === NOTICE_ABSENT) {
    account.subscription_notice_end_date = null
    account.subscription_type = ACCOUNT_STATUS.CANCELED
    account.deletion_base_at = account.deletion_base_at || from
  } else if (mode === NOTICE_WITH_DATE) {
    account.subscription_type = ACCOUNT_STATUS.IN_NOTICE
    account.deletion_base_at = null
  }

  applyNoticeToContract(account, from)
}

export function contractEndForNotice(account, from = todayISO()) {
  if (!hasNoticeRecord(account))
    return null

  if (account.subscription_notice_mode === NOTICE_ABSENT)
    return account.deletion_base_at || from

  if (account.subscription_notice_mode === NOTICE_WITH_DATE)
    return account.subscription_notice_end_date || null

  return null
}

export function applyNoticeToContract(account, from = todayISO()) {
  const end = contractEndForNotice(account, from)

  if (!end || !account.contract_document)
    return false

  const document = account.contract_document

  if (document.renewal_mode === 'date' && document.end_date === end)
    return false

  document.renewal_mode = 'date'
  document.end_date = end

  return true
}

export function canRetain(account, from = todayISO()) {
  if (!hasNoticeRecord(account))
    return false

  const days = daysUntil(deletionDateFor(account.deletion_base_at), from)

  return days === null || days >= 0
}

export function partialDate(value) {
  const year = Number(String(value || '').substring(0, 4))

  return !year || year < 1000
}

export function noticeDateError(value, from = todayISO()) {
  const days = daysUntil(value, from)

  return days !== null && days < 0 ? PAST_NOTICE_DATE_ERROR : null
}

export function noticeExpired(account, from = todayISO()) {
  if (account.subscription_notice_mode !== NOTICE_WITH_DATE)
    return false

  const days = daysUntil(account.subscription_notice_end_date, from)

  return days !== null && days < 0
}
